import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import App from "./App";

import { Provider } from "react-redux";
import { store } from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";

waitForEnv().then(() => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
      <Toaster position="bottom-right" reverseOrder={false} />
    </BrowserRouter>
  );
});

async function waitForEnv(maxRetries = 4, delay = 200) {
  let attempts = 0;

  while (!window.zino_env && attempts < maxRetries) {
    await new Promise((resolve) => setTimeout(resolve, delay));
    attempts++;
  }

  if (!window.zino_env) {
    throw new Error("Failed to load environment config after 2 attempts");
  }
}
